// GENERATED FILE — do not edit.
// Synced from api/src/zero/queries.ts via `bun run sync:zero`.
// Edit the source there, then re-run the sync.

// Synced (server-validated) Zero queries. The query fns run on the server at
// /api/zero/query with the authenticated `ctx` (userID from the JWT), so the
// row filtering is authoritative. The same definitions are shared with the web
// client (synced into apps/web), which references them by name via useQuery.

import { defineQueries, defineQuery } from '@rocicorp/zero';

import { zql } from './schema';

export const queries = defineQueries({
    host: {
        // The signed-in user's non-deleted hosts.
        mine: defineQuery(({ ctx }) =>
            zql.host.where('userId', ctx.userID).where('isDeleted', false),
        ),
    },
    workspace: {
        // The signed-in user's terminal workspace row (or undefined).
        mine: defineQuery(({ ctx }) =>
            zql.terminalWorkspace.where('userId', ctx.userID).one(),
        ),
    },
});

export type Queries = typeof queries;
